import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import {useSelector, useDispatch} from "react-redux";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import {closeDrawer} from "../../actions/drawerActions";
import {getQuestionnaireGraph, clearQuestionnaireGraph} from "../../actions/questionnaireTemplateActions";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import * as TEMPLATE from "../../constants/templateConstants";
import ArgoPortalPreviewHook from "../common/ArgoPortalPreviewHook";
import * as portalShared from "../../portal/shared/metadataConstantsAndUtilities"

const QuestionnairePortalPreviewDrawer = ({ templateId }) => {
    const dispatch = useDispatch();
    const questionnaireTemplateGraph = useSelector(state => state.questionnaireTemplateGraph);

    useEffect(() => {
        dispatch(getQuestionnaireGraph(templateId));

        return () => {
            dispatch(clearQuestionnaireGraph());
        };
    }, [dispatch, templateId]);

    const handleCloseDrawer = () => {
        dispatch(closeDrawer());
    };

    const handleClickAway = (event) => {
        // Checks is target is BODY first because portal preview DDLBs cause target to be body and we shouldn't close on that
        if (event.target.tagName !== 'BODY') {
            handleCloseDrawer();
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                e.preventDefault()
                handleCloseDrawer()
            }
        }

        document.addEventListener("keydown", handleKeyDown, true)

        return () => {document.removeEventListener("keydown", handleKeyDown, true)}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let templateGraphClone = portalShared.cloneObj(questionnaireTemplateGraph);

    // Wait for questionnaire template graph to be returned from the server
    if (templateGraphClone?.id) {
        return (
            <ClickAwayListener onClickAway={handleClickAway}>
                <div id="QuestionnairePortalPreviewDrawer-container-div" style={{height: "100%"}}>
                    <ArgoAppBarHook
                        title={"Portal Preview:"}
                        titleFor={templateGraphClone.name}
                        qualifierFor={templateGraphClone.nameQualifier}
                        showMenuArrowButton="LEFT"
                        onLeftIconButtonTouchTap={handleCloseDrawer}
                        isDrawer={true}
                        width={questionnairePortalPreviewDrawerProps.width}
                    />

                    <div style={{height: '64px'}}></div>

                    <div id="QuestionnairePortalPreviewDrawer-div">
                        <ArgoPortalPreviewHook
                            calledBy="QuestionnairePortalPreviewDrawer"
                            templateType={TEMPLATE.TYPE.QUESTIONNAIRE_GRAPH}
                            template={templateGraphClone}
                            templateGraph={templateGraphClone}
                        />
                    </div>
                </div>
            </ClickAwayListener>
        )
    }
    
    return null;
};

QuestionnairePortalPreviewDrawer.defaultProps = {

};

QuestionnairePortalPreviewDrawer.propTypes = {
    templateId: PropTypes.number
};

const questionnairePortalPreviewDrawerProps = {
    opensecondary: true,
    width: "55%",
    docked: false,
    anchor: "right"
};

export default QuestionnairePortalPreviewDrawer;
export {questionnairePortalPreviewDrawerProps};
